if (!customElements.get('styling-with-fila')) {
  class StylingWithFila extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const initWhenVisible = () => {
        if ('IntersectionObserver' in window) {
          this._observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
              this._observer.disconnect();
              this.init();
            }
          }, { rootMargin: '300px' });
          this._observer.observe(this);
        } else {
          this.init();
        }
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWhenVisible, { once: true });
      } else {
        initWhenVisible();
      }
    }

    init() {
      this.sliders = this.querySelectorAll('[data-fila-roller]');
      if (!this.sliders.length) return;
      this.sliders.forEach(slider => this.setupSlider(slider));

      // Modal setup
      this.setupModal();
    }

    setupModal() {
      const root = this;
      const modal = this.querySelector('[data-style-modal]');
      if (!modal) return;

      const modalOverlay = modal.querySelector('[data-style-modal-overlay]');
      const modalClose = modal.querySelector('[data-style-modal-close]');
      const modalSlider = modal.querySelector('[data-modal-slider]');
      const modalTrack = modal.querySelector('[data-modal-track]');
      const productGroups = modal.querySelectorAll('[data-modal-products-group]');
      const addToCartBtn = modal.querySelector('[data-modal-add-to-cart]');
      const selectAll = modal.querySelector('[data-modal-select-all]');
      const totalEl = modal.querySelector('[data-modal-total]');
      const sizeErrorEl = modal.querySelector('[data-modal-size-error]');

      // 공통 모달 슬라이더 컴포넌트 사용
      const modalImageSlider = new ModalImageSlider(modalSlider, modalTrack);

      function formatMoney(cents) {
        const amount = Math.floor(cents / 100);
        return amount.toLocaleString('ko-KR') + '원';
      }

      function getActiveGroup() {
        return modal.querySelector('[data-modal-products-group]:not([hidden])') || null;
      }

      function showSizeError() {
        if (!sizeErrorEl) return;
        sizeErrorEl.removeAttribute('hidden');
        sizeErrorEl.classList.remove('active');
        void sizeErrorEl.offsetWidth;
        sizeErrorEl.classList.add('active');

        setTimeout(() => {
          sizeErrorEl.classList.remove('active');
          sizeErrorEl.setAttribute('hidden', '');
        }, 2500);
      }

      function hideSizeError() {
        if (!sizeErrorEl) return;
        sizeErrorEl.classList.remove('active');
        sizeErrorEl.setAttribute('hidden', '');
      }

      function resetModalState() {
        const activeGroup = getActiveGroup();
        if (!activeGroup) return;

        activeGroup.querySelectorAll('[data-style-product-check]').forEach((checkbox) => {
          checkbox.checked = false;
        });

        activeGroup.querySelectorAll('[data-style-product-row]').forEach((row) => {
          const idInput = row.querySelector('[data-multi-variant-id-input]');
          const cartButton = row.querySelector('[data-multi-cart-button]');
          const toggle = row.querySelector('[data-variant-toggle]');
          const options = row.querySelector('[data-variant-options]');
          const radios = row.querySelectorAll('.style-modal-product__variant-option input[type="radio"]');

          if (idInput) idInput.value = '';
          if (cartButton) cartButton.dataset.variantId = '';

          radios.forEach((radio) => {
            radio.checked = false;
          });

          if (toggle) toggle.setAttribute('aria-expanded', 'false');
          if (options) options.hidden = true;

          // 토글 라벨 초기화
          const toggleLabel = row.querySelector('.style-modal-product__variant-label');
          if (toggleLabel) {
            toggleLabel.textContent = '사이즈 선택';
          }
        });

        if (selectAll) selectAll.checked = false;

        updateTotal();
        hideSizeError();
      }

      function getDiscountedPriceCents(row) {
        var priceDisplay = row.querySelector('.price-display');
        if (!priceDisplay) return null;
        var discountType = sessionStorage.getItem('discount_type');
        if (!discountType) return null;
        var typeKeyMap = {
          'emp_sl_uprc': 'emp', 'frds_sl_uprc1': 'frds1',
          'frds_sl_uprc2': 'frds2', 'frds_sl_uprc3': 'frds3',
          'donation': 'donation', 'normal': 'normal', '': 'normal'
        };
        var tk = typeKeyMap[discountType] || 'normal';
        var dp = priceDisplay.getAttribute('data-price-' + tk);
        if (dp && parseInt(dp, 10) > 0) return parseInt(dp, 10);
        return null;
      }

      function updateTotal() {
        if (!totalEl) return;
        const activeGroup = getActiveGroup();
        if (!activeGroup) {
          totalEl.textContent = formatMoney(0);
          return;
        }

        let cents = 0;
        activeGroup.querySelectorAll('[data-style-product-row]').forEach((row) => {
          const checkbox = row.querySelector('[data-style-product-check]');
          const checkedRadio = row.querySelector('.style-modal-product__variant-option input[type="radio"]:checked');

          if (!checkbox || !checkedRadio) return;
          if (!checkbox.checked || checkbox.disabled) return;

          const optionLabel = checkedRadio.closest('.style-modal-product__variant-option');
          if (!optionLabel || optionLabel.classList.contains('restock-button')) return;

          // Use discounted price from price-display if available
          var discounted = getDiscountedPriceCents(row);
          if (discounted !== null) {
            cents += discounted;
          } else {
            const priceStr = optionLabel.getAttribute('data-price') || '0';
            const priceInt = parseInt(priceStr, 10);
            if (!isNaN(priceInt)) cents += priceInt;
          }
        });

        totalEl.textContent = formatMoney(cents);
      }

      // 모달을 body로 이동 (stacking context 문제 해결)
      if (modal && modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      function openModal(slide) {
        const index = slide.getAttribute('data-slide-index');
        if (!index) return;

        // JSON 데이터에서 카드의 이미지 목록 가져오기
        let images = [];
        const cardImagesScript = root.querySelector(`script[data-card-images="${index}"]`);
        if (cardImagesScript) {
          try {
            images = JSON.parse(cardImagesScript.textContent);
          } catch (e) {
            console.error('Failed to parse card images:', e);
          }
        }

        // JSON 데이터가 없으면 클릭한 슬라이드의 이미지만 사용
        if (images.length === 0) {
          const img = slide.querySelector('img');
          if (img) {
            images.push({ src: img.src, alt: img.alt || 'Style image' });
          }
        }

        // 공통 슬라이더 컴포넌트로 이미지 설정
        modalImageSlider.setImages(images);

        productGroups?.forEach((group) => {
          if (group.getAttribute('data-slide-index') === index) {
            group.removeAttribute('hidden');
          } else {
            group.setAttribute('hidden', '');
          }
        });

        modal.hidden = false;
        document.documentElement.classList.add('women-styles-modal-open');
        updateTotal();
        updateSelectAllState();
      }

      function closeModal() {
        resetModalState();
        modalImageSlider.reset();
        modal.hidden = true;
        document.documentElement.classList.remove('women-styles-modal-open');
      }

      modalOverlay?.addEventListener('click', closeModal);
      modalClose?.addEventListener('click', closeModal);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });

      // Click on slides with products (event delegation for cloned slides)
      root.addEventListener('click', (e) => {
        const slide = e.target.closest('[data-style-slide]');
        if (!slide) return;
        if (root.querySelector('.is-dragging')) return;

        // dataLayer: main_click (style) — Shop the Look
        if (typeof FilaDL !== 'undefined') {
          var imgEl = slide.querySelector('img');
          FilaDL.push({
            event: 'main_click',
            click: {
              type: 'style',
              img_url: imgEl ? (imgEl.currentSrc || imgEl.src || '') : '',
              main_box_name: 'Shop the Look',
              page_type: FilaDL.getMainPageType()
            }
          });
        }

        openModal(slide);
      });

      // 사이즈 토글 버튼 및 옵션 선택 이벤트
      const rows = modal.querySelectorAll('[data-style-product-row]');

      // 사이즈 옵션 정렬 (PDP와 동일한 compareSizes 사용)
      rows.forEach((row) => {
        const optionsContainer = row.querySelector('[data-variant-options]');
        if (!optionsContainer) return;

        const labels = Array.from(optionsContainer.querySelectorAll('.style-modal-product__variant-option'));
        if (labels.length <= 1) return;

        labels.sort((a, b) => {
          const titleA = a.querySelector('.style-modal-product__variant-title')?.textContent?.trim() || '';
          const titleB = b.querySelector('.style-modal-product__variant-title')?.textContent?.trim() || '';
          return compareSizes(titleA, titleB);
        });

        labels.forEach((label) => optionsContainer.appendChild(label));
      });

      rows.forEach((row) => {
        const toggle = row.querySelector('[data-variant-toggle]');
        const options = row.querySelector('[data-variant-options]');

        if (toggle && options) {
          toggle.addEventListener('click', () => {
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', !isExpanded);
            options.hidden = isExpanded;
          });
        }
      });

      rows.forEach((row) => {
        const variantOptions = row.querySelectorAll('.style-modal-product__variant-option');
        const idInput = row.querySelector('[data-multi-variant-id-input]');
        const cartButton = row.querySelector('[data-multi-cart-button]');
        const priceEl = row.querySelector('[data-variant-price]');
        const checkbox = row.querySelector('[data-style-product-check]');

        if (!idInput || !cartButton) return;

        variantOptions.forEach((option) => {
          option.addEventListener('click', (e) => {
            // 품절 상품 클릭 시 입고알림 처리
            if (option.classList.contains('restock-button')) {
              e.preventDefault();
              const productId = option.dataset.productId;
              const variantId = option.dataset.variantId;

              const restockEvent = new CustomEvent('restock:request', {
                bubbles: true,
                detail: { productId, variantId }
              });
              option.dispatchEvent(restockEvent);
              return;
            }

            // 라디오 버튼 체크
            const radio = option.querySelector('input[type="radio"]');
            if (radio) {
              radio.checked = true;
            }

            // variant ID 및 가격 업데이트
            const variantId = option.dataset.variantId;
            const priceCents = parseInt(option.dataset.price || '0', 10);

            idInput.value = variantId;
            cartButton.dataset.variantId = variantId;

            if (!isNaN(priceCents) && priceEl) {
              // Preserve price-display if it exists (employee/friends discount)
              if (!priceEl.querySelector('.price-display')) {
                priceEl.textContent = formatMoney(priceCents);
              }
            }

            // 체크박스 자동 선택
            if (checkbox && !checkbox.checked && !checkbox.disabled) {
              checkbox.checked = true;
            }

            // 토글 라벨에 선택된 사이즈 표시
            const selectedSize = option.querySelector('.style-modal-product__variant-title')?.textContent?.trim();
            const toggleLabel = row.querySelector('.style-modal-product__variant-label');
            if (toggleLabel && selectedSize) {
              toggleLabel.textContent = selectedSize;
            }

            updateTotal();
            updateSelectAllState();
          });
        });

        // 초기 상태: 선택된 사이즈 없음
        idInput.value = '';
        cartButton.dataset.variantId = '';
      });

      function updateSelectAllState() {
        if (!selectAll) return;
        const activeGroup = getActiveGroup();
        if (!activeGroup) return;

        const boxes = Array.from(
          activeGroup.querySelectorAll('[data-style-product-check]')
        ).filter((box) => !box.disabled);

        if (!boxes.length) {
          selectAll.checked = false;
          return;
        }

        const allChecked = boxes.every((b) => b.checked);
        selectAll.checked = allChecked;
      }

      if (selectAll) {
        selectAll.addEventListener('change', () => {
          const isChecked = selectAll.checked;
          const activeGroup = getActiveGroup();
          if (!activeGroup) return;

          activeGroup.querySelectorAll('[data-style-product-row]').forEach((row) => {
            const checkbox = row.querySelector('[data-style-product-check]');
            const toggle = row.querySelector('[data-variant-toggle]');
            const options = row.querySelector('[data-variant-options]');

            if (!checkbox || checkbox.disabled) return;
            checkbox.checked = isChecked;

            // 전체선택 시 모든 사이즈 박스 열기
            if (isChecked) {
              if (toggle) toggle.setAttribute('aria-expanded', 'true');
              if (options) options.removeAttribute('hidden');
            }
          });

          updateTotal();
        });
      }

      modal.addEventListener('change', (e) => {
        if (e.target.matches('[data-style-product-check]')) {
          const checkbox = e.target;
          const row = checkbox.closest('[data-style-product-row]');
          const idInput = row?.querySelector('[data-multi-variant-id-input]');
          const toggle = row?.querySelector('[data-variant-toggle]');
          const options = row?.querySelector('[data-variant-options]');

          // 사이즈 미선택 상태에서 체크 시 사이즈 선택창 열기
          if (checkbox.checked && idInput && !idInput.value && toggle && options) {
            toggle.setAttribute('aria-expanded', 'true');
            options.hidden = false;
          }

          updateSelectAllState();
          updateTotal();
        }
      });

      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', async (evt) => {
          evt.preventDefault();
          const activeGroup = getActiveGroup();
          if (!activeGroup) return;

          const groupRows = activeGroup.querySelectorAll('[data-style-product-row]');

          // 체크된 상품 중 사이즈 미선택 상품이 있는지 확인
          let hasCheckedItems = false;
          let hasMissingSize = false;

          groupRows.forEach((row) => {
            const checkbox = row.querySelector('[data-style-product-check]');
            const idInput = row.querySelector('[data-multi-variant-id-input]');

            if (!checkbox || checkbox.disabled) return;
            if (!checkbox.checked) return;

            hasCheckedItems = true;

            if (!idInput || !idInput.value) {
              hasMissingSize = true;
            }
          });

          // 체크된 상품이 없으면 에러 표시
          if (!hasCheckedItems) {
            showSizeError();
            return;
          }

          // 사이즈 미선택 상품이 있으면 에러 표시
          if (hasMissingSize) {
            showSizeError();
            return;
          }

          // 모든 체크된 상품을 장바구니에 추가
          const items = [];
          groupRows.forEach((row) => {
            const checkbox = row.querySelector('[data-style-product-check]');
            const idInput = row.querySelector('[data-multi-variant-id-input]');

            if (!checkbox || checkbox.disabled || !checkbox.checked) return;
            if (!idInput || !idInput.value) return;

            items.push({
              id: parseInt(idInput.value, 10),
              quantity: 1
            });
          });

          if (items.length === 0) return;

          addToCartBtn.disabled = true;
          addToCartBtn.textContent = '담는 중...';

          try {
            const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];

            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items,
                sections: sectionsToRender,
                sections_url: window.location.pathname
              })
            });

            if (!response.ok) throw new Error('Cart add failed: ' + response.status);

            const data = await response.json();

            if (data.status && data.status !== 200) {
              alert(data.description || data.message || '장바구니 추가 중 오류가 발생했습니다.');
              return;
            }

            // dataLayer: add_to_cart (main)
            if (typeof FilaDL !== 'undefined') {
              try {
                var dlItems = [];
                var dlValue = 0;
                groupRows.forEach(function(row) {
                  var checkbox = row.querySelector('[data-style-product-check]');
                  if (!checkbox || !checkbox.checked) return;
                  var jsonEl = row.querySelector('[data-dl-product-data]');
                  if (!jsonEl) return;
                  var productData = JSON.parse(jsonEl.textContent);
                  var item = FilaDL.buildItem(productData);
                  item.quantity = 1;
                  dlItems.push(item);
                  dlValue += item.price;
                });
                if (dlItems.length > 0) {
                  FilaDL.pushEcommerce({
                    event: 'add_to_cart',
                    page_type: 'main',
                    ecommerce: { currency: 'KRW', value: dlValue, items: dlItems }
                  });
                }
              } catch(e) {}
            }

            closeModal();

            // 장바구니 업데이트 이벤트 발행
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'styling-with-fila',
                cartData: data,
              });
            }

            // React 장바구니 모달 열기 (상품별 개별 이벤트 디스패치)
            items.forEach(item => {
              window.dispatchEvent(new CustomEvent('open-cart-modal', {
                detail: {
                  cartType: 'NORMAL',
                  isAdded: true,
                  noSetDraw: true,
                  variantId: String(item.id),
                  quantity: item.quantity
                }
              }));
            });
          } catch (err) {
            console.error('장바구니 추가 오류:', err);
            alert('장바구니 추가 중 오류가 발생했습니다.');
          } finally {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = '장바구니 담기';
          }
        });
      }
    }

    setupSlider(slider) {
      const slides = Array.from(slider.querySelectorAll('[data-fila-slide]'));
      if (slides.length < 2) return;

      const track = document.createElement('div');
      track.className = 'fila-slider__track';
      track.setAttribute('data-fila-track', '');

      // 슬라이드 복제하여 무한 루프 효과
      slides.forEach(slide => track.appendChild(slide));
      slides.forEach(slide => track.appendChild(slide.cloneNode(true)));

      // 복제된 이미지 lazy 처리 (즉시 로딩 방지)
      const clonedImages = Array.from(track.querySelectorAll('[data-fila-slide]:nth-child(n+' + (slides.length + 1) + ') img'));
      clonedImages.forEach(img => {
        img.dataset.src = img.src;
        img.removeAttribute('src');
        if (img.srcset) {
          img.dataset.srcset = img.srcset;
          img.removeAttribute('srcset');
        }
      });

      // 복제 이미지 뷰포트 진입 시 로드
      if ('IntersectionObserver' in window) {
        const imgObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const img = entry.target;
              if (img.dataset.src) img.src = img.dataset.src;
              if (img.dataset.srcset) img.srcset = img.dataset.srcset;
              imgObserver.unobserve(img);
            }
          });
        }, { rootMargin: '200px' });
        clonedImages.forEach(img => imgObserver.observe(img));
      }

      slider.appendChild(track);

      let x = 0;
      let isDragging = false;
      let startX = 0;
      let startTranslateX = 0;
      let velocity = 0;
      let lastX = 0;
      let lastTime = 0;

      const getLoopWidth = () => track.scrollWidth / 2;

      const updateTransform = (applyLoop = true) => {
        if (applyLoop) {
          const loopWidth = getLoopWidth();
          // 무한 루프 처리
          if (x > 0) {
            x = x - loopWidth;
          } else if (x < -loopWidth) {
            x = x + loopWidth;
          }
        }
        track.style.transform = `translateX(${x}px)`;
      };

      // 관성 스크롤 애니메이션
      const applyMomentum = () => {
        if (Math.abs(velocity) > 0.5) {
          x += velocity;
          velocity *= 0.95; // 감속
          updateTransform();
          requestAnimationFrame(applyMomentum);
        }
      };

      // Touch events for mobile - 드래그/클릭 구분 및 민감도 개선
      let touchStartY = 0;
      let isHorizontalDrag = false;
      let touchMoved = false;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const touchSensitivity = isMobile ? 1.5 : 1; // 모바일 민감도 향상

      const handleTouchStart = (e) => {
        isDragging = true;
        isHorizontalDrag = false;
        touchMoved = false;
        startX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        startTranslateX = x;
        lastX = startX;
        lastTime = Date.now();
        velocity = 0;
        track.style.transition = 'none';
      };

      const handleTouchMove = (e) => {
        if (!isDragging) return;
        const currentX = e.touches[0].clientX;
        const currentY = e.touches[0].clientY;
        const currentTime = Date.now();
        const diffX = currentX - startX;
        const diffY = currentY - touchStartY;

        // 첫 움직임에서 수평/수직 드래그 판단
        if (!isHorizontalDrag && !touchMoved) {
          if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 10) {
            isHorizontalDrag = true;
            touchMoved = true;
          } else if (Math.abs(diffY) > Math.abs(diffX) && Math.abs(diffY) > 10) {
            // 수직 스크롤 - 드래그 취소하고 기본 동작 허용
            isDragging = false;
            return;
          }
        }

        if (!isHorizontalDrag) return;
        e.preventDefault();
        touchMoved = true;

        // 속도 계산 (민감도 적용)
        if (currentTime - lastTime > 0) {
          velocity = ((currentX - lastX) / (currentTime - lastTime) * 16) * touchSensitivity;
        }
        lastX = currentX;
        lastTime = currentTime;

        x = startTranslateX + (diffX * touchSensitivity);
        updateTransform(false);
      };

      const handleTouchEnd = (e) => {
        if (!isDragging) return;
        isDragging = false;

        // 드래그 없이 탭만 했으면 링크 클릭 허용
        if (!touchMoved) {
          return;
        }

        applyMomentum();
      };

      // Mouse events for desktop - 드래그앤드롭 슬라이딩
      let mouseDownX = 0;
      let hasDragged = false;

      const handleMouseDown = (e) => {
        e.preventDefault();
        isDragging = true;
        hasDragged = false;
        startX = e.clientX;
        mouseDownX = e.clientX;
        startTranslateX = x;
        lastX = startX;
        lastTime = Date.now();
        velocity = 0;
        track.style.transition = 'none';
        track.style.cursor = 'grabbing';
      };

      const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const currentX = e.clientX;
        const currentTime = Date.now();
        const diff = currentX - startX;

        // 5px 이상 이동하면 드래그로 간주
        if (Math.abs(currentX - mouseDownX) > 5) {
          hasDragged = true;
          slider.classList.add('is-dragging');
        }

        // 속도 계산
        if (currentTime - lastTime > 0) {
          velocity = (currentX - lastX) / (currentTime - lastTime) * 16;
        }
        lastX = currentX;
        lastTime = currentTime;

        x = startTranslateX + diff;
        updateTransform(false);
      };

      const handleMouseUp = () => {
        if (!isDragging) return;
        isDragging = false;
        track.style.cursor = 'grab';
        setTimeout(() => {
          slider.classList.remove('is-dragging');
        }, 50);
        if (hasDragged) {
          applyMomentum();
        }
        hasDragged = false;
      };

      const handleMouseLeave = () => {
        if (isDragging) {
          handleMouseUp();
        }
      };

      // 이미지 드래그 방지
      track.querySelectorAll('img').forEach(img => {
        img.draggable = false;
        img.style.pointerEvents = 'none';
      });

      // Add touch event listeners
      track.addEventListener('touchstart', handleTouchStart, { passive: false });
      track.addEventListener('touchmove', handleTouchMove, { passive: false });
      track.addEventListener('touchend', handleTouchEnd);

      // Add mouse event listeners
      track.addEventListener('mousedown', handleMouseDown);
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      slider.addEventListener('mouseleave', handleMouseLeave);

      // Set initial cursor
      track.style.cursor = 'grab';

      // 초기 위치 설정
      updateTransform();

      // 자동 슬라이딩 기능
      let autoScrollId = null;
      const autoScrollSpeed = 0.5; // 자동 스크롤 속도 (픽셀/프레임)

      const autoScroll = () => {
        if (!isDragging && Math.abs(velocity) < 0.5) {
          x -= autoScrollSpeed;
          updateTransform();
        }
        autoScrollId = requestAnimationFrame(autoScroll);
      };

      // 자동 슬라이딩 시작
      autoScroll();

      // 드래그 시작 시 자동 슬라이딩 일시 정지 (velocity로 제어됨)
      // 드래그 끝나고 관성이 멈추면 자동 슬라이딩 재개됨
    }
  }
  customElements.define('styling-with-fila', StylingWithFila);
}